import { render } from "./GenderSelector.vue?vue&type=template&id=488fb597"
import script from "./GenderSelector.vue?vue&type=script&lang=js"
export * from "./GenderSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/GenderSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "488fb597"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('488fb597', __exports__)) {
    api.reload('488fb597', __exports__)
  }
  
  module.hot.accept("./GenderSelector.vue?vue&type=template&id=488fb597", () => {
    api.rerender('488fb597', render)
  })

}


export default __exports__